import * as React from "react";
const SvgAngleDown = (props) => /* @__PURE__ */ React.createElement("svg", { height: 24, width: 24, fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M19 9l-7 7-7-7" }));
export default SvgAngleDown;
